import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const TrustBand = () => {
  const { t } = useLanguage();

  const signals = [
    { label: t("trust.handmade") },
    { label: t("trust.delivered") },
    { label: t("trust.delivery_time") },
  ];

  return (
    <section className="py-8 px-6 border-b border-border/50">
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center gap-x-12 gap-y-3">
        {signals.map((s, i) => (
          <motion.span
            key={s.label}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-xs tracking-[0.15em] uppercase text-muted-foreground"
          >
            {s.label}
          </motion.span>
        ))}
      </div>
    </section>
  );
};

export default TrustBand;
